import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { IceapiService } from '../../../../../services';
import { NutDimensionModel } from '../../../models';
// import { appInsights } from 'src/app/app.module';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
@Component({
    selector: 'app-nut-standard',
    templateUrl: './nut-standard.component.html',
    styleUrls: ['./nut-standard.component.scss'],
    standalone: false
})
export class NutStandardComponent {
    @Input() form: UntypedFormGroup;
    @Input()
    set boltDimensionId(value: string) {
        this._boltDimensionId = value;
        this.getNutDimensions();
    }
    get boltDimensionId(): string {
        return this._boltDimensionId;
    }

    tooltip_position = 'above';
    loading: boolean = false;
    nutDimensionList: NutDimensionModel[];
    private _boltDimensionId: string;
    constructor(
        private iceapi: IceapiService,
        private user_utility: UserUtilityService,
        private cd: ChangeDetectorRef,
        private appInsights: ApplicationInsights
    ) {}

    getNutDimensions(): void {
        if (this.boltDimensionId != undefined) {
            this.loading = true;

            this.iceapi
                .getNutDimensions(this.boltDimensionId)
                .pipe(
                    finalize(() => {
                        this.loading = false;
                    })
                )
                .subscribe(
                    (nutDimensionModel) => {
                        if (nutDimensionModel.success === true) {
                            this.nutDimensionList = nutDimensionModel.response;
                            if (this.nutDimensionList.length === 1)
                                this.form.get('nutStandard').setValue(this.nutDimensionList[0].nutDimensionId, { emitEvent: false });
                            this.cd.markForCheck();
                        } else {
                            this.user_utility.errorModelPopup(nutDimensionModel.message);
                        }
                    },
                    (err) => {
                        this.appInsights.trackException({ exception: new Error(err) });
                    }
                );
        }
    }
}
